import React from "react";
import { Route, Routes } from "react-router";
import ServiceRAFA from "../../components/Jobs/Job/ServiceRAFA";
import ServiceRAFATeamlead from "../../components/Jobs/Job/ServiceRAFATeamlead";
import JobOverviewPage from "../../containers/Pages/Generic/JobsPage/JobOverviewPage";
import Error404Page from "../../containers/Pages/Generic/Error404/Error404Page";
import Attorney from "../../components/Jobs/Job/Attorney";
import LegalTrainee from "../../components/Jobs/Job/LegalTrainee";
import ProductManager from "../../components/Jobs/Job/ProductManager";
import useTracker from "../../services/useTracker";
import SeniorDeveloper from "../../components/Jobs/Job/SeniorDeveloper";
import BusinessLawyer from "../../components/Jobs/Job/BusinessLawyer";

export default function Jobs() {
  useTracker();

  return (
    <Routes>
      <Route path={`kanzleimanagement-teamleitung-mwd`} element={<ServiceRAFATeamlead />} />
      <Route path={`rechtsanwaltsfachangestellter-mwd`} element={<ServiceRAFA />} />
      <Route path={`rechtsanwalt-mwd`} element={<Attorney />} />
      <Route path={`wirtschaftsjurist-mwd`} element={<BusinessLawyer />} />
      <Route path={`rechtsreferendar-mwd`} element={<LegalTrainee />} />
      <Route path={`productmanager-legaltech-mwd`} element={<ProductManager />} />
      <Route path={`developer-mwd`} element={<SeniorDeveloper />} />
      <Route path={``} element={<JobOverviewPage />} />
      <Route path={`*`} element={<Error404Page />} />
    </Routes>
  );
}
